var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 17.0625C7.9625 17.0625 8.75 16.275 8.75 15.3125H5.25C5.25 16.275 6.02875 17.0625 7 17.0625ZM12.25 11.8125V7.4375C12.25 4.75125 10.815 2.5025 8.3125 1.9075V1.3125C8.3125 0.58625 7.72625 0 7 0C6.27375 0 5.6875 0.58625 5.6875 1.3125V1.9075C3.17625 2.5025 1.75 4.7425 1.75 7.4375V11.8125L0 13.5625V14.4375H14V13.5625L12.25 11.8125Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.255d3263.svg";
export { ForwardRef as ReactComponent };